import { CourseType, SynchronousCourseTypes } from 'enum'
import { CreateNewCourseForm } from './types'
import { ShowDates } from './constants'

export const defaultValues: CreateNewCourseForm = {
  name: '',
  banner: undefined,
  thumbnail: undefined,
  description: '',
  courseType: CourseType.Open,
  courseTypeSynchronous: SynchronousCourseTypes.external,
  startDate: undefined,
  courseExternal: '',
  untilDate: undefined,
  optionalProfiles: [],
  requiredProfiles: [],
  state: undefined,
  directChiefApproval: false,
  showDates: ShowDates.inactive,
  invitationNotification: null,
  lessons: [],
  hasStarted: false,
  canGenerateCertificate: false,
  reminderNotification: undefined,
  courseSynchronousProperties: {},
  courseSynchronous: false,
}

export const defaultErrors = {
  name: '',
  description: '',
  banner: '',
  thumbnail: '',
  courseType: '',
  startDate: '',
  untilDate: '',
  optionalProfiles: '',
  requiredProfiles: '',
  state: '',
  sendEmail: '',
  invitationNotification: '',
  lessons: '',
  hasStarted: '',
}
